import { io, type Socket } from "socket.io-client";

export type PrintJob = {
	fileId: number;
	jobKey: string;
	printerType: "Imprimante" | "Imprimante UPS" | "Imprimante Etiquettes";
	title?: string;
	options?: object;
};

export type CommandReadyDocumentsReadyPayload = {
	requesterUserId: number;
	jobs: PrintJob[];
};

export type PrintDocumentsReadyPayload = {
	requesterUserId: number;
	jobs: PrintJob[];
};

export const socket: Socket = io(import.meta.env.VITE_WS_URL);
